import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { galleryItemsInfiniteQueryOptions } from "~/features/gallery/api";
import { GalleryTemplate } from "~/features/gallery/GalleryTemplate";

const gallerySearchSchema = z.object({
  type: z.enum(["movie", "image"]).catch("movie"),
  favoritesOnly: z.coerce.boolean().catch(false),
  status: z.enum(["unopened", "opened"]).catch("unopened"),
});

export const Route = createFileRoute("/_authenticated/gallery")({
  validateSearch: gallerySearchSchema,
  loaderDeps: ({ search }) => ({ type: search.type, status: search.status }),
  loader: ({ context: { queryClient }, deps }) =>
    queryClient.ensureInfiniteQueryData(
      galleryItemsInfiniteQueryOptions(deps.type, deps.status),
    ),
  component: GalleryTemplate,
});
